module.exports = __webpack_public_path__ + "img/B01_HQ08.6cd5c3e1.jpg";